/* The Cozy Foundry Home theme */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2600);
  }

  /* ---------- focus trap helper (shared by menu / cart / wishlist dialogs) ---------- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function getFocusable(container) {
    return $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
  }
  function trapFocus(container) {
    if (!container || container._trapActive) return;
    container._trapActive = true;
    container._lastFocused = document.activeElement;
    var items = getFocusable(container);
    if (items.length) { items[0].focus(); }
    container._trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var focusables = getFocusable(container);
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', container._trapHandler);
  }
  function releaseFocus(container) {
    if (!container || !container._trapActive) return;
    container._trapActive = false;
    if (container._trapHandler) { container.removeEventListener('keydown', container._trapHandler); container._trapHandler = null; }
    if (container._lastFocused && typeof container._lastFocused.focus === 'function') { container._lastFocused.focus(); }
    container._lastFocused = null;
  }

  /* ---------- mobile menu drawer (single instance) ---------- */
  var menuDrawer = $('.drawer');
  var menuOverlay = $('.drawer-overlay');
  function openMenu() {
    if (!menuDrawer) return;
    closeCart();
    closeWishlist();
    menuDrawer.classList.add('open');
    menuDrawer.setAttribute('aria-hidden', 'false');
    menuOverlay && menuOverlay.classList.add('open');
    document.body.classList.add('no-scroll');
    trapFocus(menuDrawer);
  }
  function closeMenu() {
    if (!menuDrawer) return;
    menuDrawer.classList.remove('open');
    menuDrawer.setAttribute('aria-hidden', 'true');
    menuOverlay && menuOverlay.classList.remove('open');
    document.body.classList.remove('no-scroll');
    releaseFocus(menuDrawer);
  }

  /* ---------- cart drawer ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  var cartOverlay = $('[data-cart-overlay]');
  function openCart() {
    if (!cartDrawer) return;
    closeMenu();
    closeWishlist();
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.classList.add('no-scroll');
    trapFocus(cartDrawer);
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.classList.remove('no-scroll');
    releaseFocus(cartDrawer);
  }

  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = n;
      if (n > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
    });
  }

  function refreshCart(open) {
    return fetch('?section_id=cart-drawer-items', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var body = $('[data-cart-body]');
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-body-inner]') || tmp;
        if (body) body.innerHTML = fresh.innerHTML;
      })
      .catch(function () {})
      .then(function () {
        return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); })
          .then(function (c) { setCartCount(c.item_count); })
          .catch(function () {});
      })
      .then(function () { if (open) openCart(); });
  }

  function changeLine(line, qty) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { return refreshCart(false); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('.menu-toggle')) { e.preventDefault(); openMenu(); return; }
    if (t.closest('.drawer-close') || t.closest('.drawer-overlay')) { closeMenu(); return; }
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]') || t.closest('[data-cart-overlay]')) { closeCart(); return; }
    if (t.closest('[data-wishlist-open]')) { e.preventDefault(); openWishlist(); return; }
    if (t.closest('[data-wishlist-close]')) { e.preventDefault(); closeWishlist(); return; }

    /* wishlist */
    var wish = t.closest('[data-wishlist-toggle]');
    if (wish) {
      e.preventDefault();
      e.stopPropagation();
      var card = wish.closest('[data-wish-id]');
      if (card) toggleWish(card, wish);
      return;
    }
    var wishRemove = t.closest('[data-wishlist-remove]');
    if (wishRemove) {
      e.preventDefault();
      removeWish(wishRemove.getAttribute('data-wishlist-remove'));
      renderWishlistPage();
      return;
    }

    /* add to cart from a card */
    var buy = t.closest('[data-buy-now]');
    if (buy) {
      e.preventDefault();
      e.stopPropagation();
      var bid = buy.getAttribute('data-variant-id');
      if (!bid) return;
      buy.classList.add('loading');
      buy.setAttribute('aria-busy', 'true');
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(bid), quantity: Number(buy.getAttribute('data-quantity') || 1) }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) { buy.classList.remove('loading'); buy.removeAttribute('aria-busy'); toast(res.description || 'Could not buy this item'); return; }
          window.location.href = '/checkout';
        })
        .catch(function () { buy.classList.remove('loading'); buy.removeAttribute('aria-busy'); toast('Could not start checkout'); });
      return;
    }

    var add = t.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      var id = add.getAttribute('data-variant-id');
      if (!id) return;
      add.classList.add('loading');
      add.setAttribute('aria-busy', 'true');
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(add.getAttribute('data-quantity') || 1) }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          add.classList.remove('loading');
          add.removeAttribute('aria-busy');
          if (res && res.status) { toast(res.description || 'Could not add this item'); return; }
          toast('Added to your bag');
          refreshCart(true);
        })
        .catch(function () { add.classList.remove('loading'); add.removeAttribute('aria-busy'); toast('Could not add this item'); });
      return;
    }

    /* cart line quantity */
    var li = t.closest('.cd-item');
    if (li) {
      var line = Number(li.getAttribute('data-line'));
      var qtyEl = $('.cd-qty span', li);
      var qty = qtyEl ? Number(qtyEl.textContent.trim()) : 1;
      if (t.closest('[data-qty-up]')) { changeLine(line, qty + 1); return; }
      if (t.closest('[data-qty-down]')) { changeLine(line, Math.max(0, qty - 1)); return; }
      if (t.closest('[data-remove]')) { changeLine(line, 0); return; }
    }

    /* footer accordion */
    var acc = t.closest('[data-accordion]');
    if (acc && window.innerWidth < 768) {
      var open = acc.getAttribute('aria-expanded') === 'true';
      acc.setAttribute('aria-expanded', open ? 'false' : 'true');
      var panel = acc.nextElementSibling;
      if (panel) panel.classList.toggle('open', !open);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); closeWishlist(); }
  });

  /* ---------- wishlist (saved on this device) ---------- */
  var KEY = 'cozy-wishlist';
  function readWish() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (err) { return []; }
  }
  function writeWish(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    paintWishCount();
  }
  function removeWish(id) {
    writeWish(readWish().filter(function (i) { return String(i.id) !== String(id); }));
  }
  function paintWishCount() {
    var n = readWish().length;
    $$('[data-wishlist-count]').forEach(function (b) {
      b.textContent = n;
      if (n > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
    });
  }
  function toggleWish(card, btn) {
    var id = card.getAttribute('data-wish-id');
    var list = readWish();
    var exists = list.some(function (i) { return String(i.id) === String(id); });
    if (exists) {
      writeWish(list.filter(function (i) { return String(i.id) !== String(id); }));
      btn.classList.remove('is-saved');
      btn.setAttribute('aria-pressed', 'false');
      toast('Removed from your wishlist');
    } else {
      list.push({
        id: id,
        title: card.getAttribute('data-wish-title'),
        url: card.getAttribute('data-wish-url'),
        image: card.getAttribute('data-wish-img'),
        price: card.getAttribute('data-wish-price')
      });
      writeWish(list);
      btn.classList.add('is-saved');
      btn.setAttribute('aria-pressed', 'true');
      toast('Loved it, saved to your wishlist');
    }
  }
  function paintWishButtons() {
    var list = readWish();
    $$('[data-wish-id]').forEach(function (card) {
      var btn = $('[data-wishlist-toggle]', card);
      if (!btn) return;
      var saved = list.some(function (i) { return String(i.id) === String(card.getAttribute('data-wish-id')); });
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }
  function openWishlist() {
    renderWishlistPage();
    var d = $('.wishlist-drawer'), o = $('.wl-overlay');
    if (!d) return;
    closeMenu();
    closeCart();
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    o && o.classList.add('open');
    document.body.classList.add('no-scroll');
    trapFocus(d);
  }
  function closeWishlist() {
    var d = $('.wishlist-drawer'), o = $('.wl-overlay');
    if (!d) return;
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true');
    o && o.classList.remove('open');
    document.body.classList.remove('no-scroll');
    releaseFocus(d);
  }
  function renderWishlistPage() {
    var grids = $$('[data-wishlist-grid]');
    if (!grids.length) return;
    var list = readWish();
    var html;
    if (!list.length) {
      html = '<div class="empty-state" style="grid-column:1/-1;"><p>Nothing saved yet. Tap the heart on any piece you love.</p></div>';
      grids.forEach(function (g) { g.innerHTML = html; });
      return;
    }
    html = list.map(function (i) {
      return '<div class="cfc"><a class="cfc-link" href="' + i.url + '"><div class="cfc-media">' +
        '<img src="' + i.image + '" alt="" loading="lazy" width="500" height="500">' +
        '</div></a><div class="cfc-meta"><h3 class="cfc-title"><a href="' + i.url + '">' + i.title + '</a></h3>' +
        '<p class="cfc-price">' + (i.price || '') + '</p>' +
        '<button class="btn btn--outline btn--sm" type="button" data-wishlist-remove="' + i.id + '">Remove</button></div></div>';
    }).join('');
    grids.forEach(function (g) { g.innerHTML = html; });
  }

  /* ---------- hero carousel: 4 seconds per slide, pausable, reduced-motion aware ---------- */
  function initHero() {
    var root = $('.hero');
    var slides = $$('.hero-slide');
    var dots = $$('.hero-dots button');
    var pauseBtn = $('.hero-pause');
    if (slides.length < 2) { if (pauseBtn) pauseBtn.hidden = true; return; }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0, timer, playing = false;

    function goTo(i) {
      slides[current].classList.remove('active');
      if (dots[current]) { dots[current].classList.remove('active'); dots[current].removeAttribute('aria-current'); }
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) { dots[current].classList.add('active'); dots[current].setAttribute('aria-current', 'true'); }
    }
    function play() {
      playing = true;
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, 4000);
      if (pauseBtn) { pauseBtn.setAttribute('aria-pressed', 'false'); pauseBtn.setAttribute('aria-label', 'Pause slideshow'); pauseBtn.classList.remove('is-paused'); }
    }
    function stop() {
      playing = false;
      clearInterval(timer);
      if (pauseBtn) { pauseBtn.setAttribute('aria-pressed', 'true'); pauseBtn.setAttribute('aria-label', 'Play slideshow'); pauseBtn.classList.add('is-paused'); }
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var wasPlaying = playing;
        stop();
        goTo(i);
        if (wasPlaying) play();
      });
    });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () { if (playing) { stop(); } else { play(); } });
    }

    if (reduce) { stop(); } else { play(); }
  }

  /* ---------- product card touch: first tap reveals, second tap opens ---------- */
  function initCards() {
    if (!window.matchMedia('(hover: none)').matches) return;
    $$('.cfc .cfc-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var card = link.closest('.cfc');
        if (!card.classList.contains('touch')) {
          e.preventDefault();
          $$('.cfc.touch').forEach(function (c) { c.classList.remove('touch'); });
          card.classList.add('touch');
        }
      });
    });
  }

  /* ---------- back to top ---------- */
  function initBackToTop() {
    var btt = document.getElementById('back-to-top');
    if (!btt) return;
    var onScroll = function () { btt.classList.toggle('show', window.scrollY > 400); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btt.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function init() {
    paintWishCount();
    paintWishButtons();
    renderWishlistPage();
    paintWishButtons();
    initHero();
    initCards();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
